import { render } from "./addstore.vue?vue&type=template&id=2b459baa"
import script from "./addstore.vue?vue&type=script&lang=js"
export * from "./addstore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__